/** @description Возвращает универсальные координаты для тач нажатия или клика
 * @param e {React.TouchEvent | React.MouseEvent} объект события мыши или тач нажатия
 * @return {{ x: number, y: number }}
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var getUniversalPosition = function getUniversalPosition(e) {
  var event = e.changedTouches && e.changedTouches[0] ? e.changedTouches[0] : e;
  return {
    x: event.clientX || 0,
    y: event.clientY || 0
  };
};